import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.5/js/sparta-events-utility";
import spartaMediaQueryUtility from "utilities/global/sparta-mediaquery-utility/2.0.4/js/sparta-mediaquery-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import Module from "utilities/global/sparta-module-utility/6.2.6/js/sparta-module-utility";
import spartaTemplates from "modules/global/search-stub-module/5.3.0/js/templates";
import "css!modules/global/search-stub-module/5.3.0/css/search-stub-module.scss.css";
/* global sparta */
/**
 * @file        search-stub-module.js
 * @description This module is responsible for rendering the global search experience.
 * @author      NBKTKHN - Dixit, Rahul
 * @copyright   © 2021 Bank of America Corporation. All rights reserved.
 */
export default class searchStubModuleJS extends Module {
  /**
   * Creates an instance of searchStubModuleJS.
   * @memberof searchStubModuleJS
   */

  /**
   * Called when this module is bootstrapped by the client.
   * @returns {void}
   */
  init() {
    if (this.params.isSearchWidget) {
      this.viewport = spartaMediaQueryUtility.matchedQuery.viewport;
      try {
        this.isAuth = (document.domain && document.domain.includes('secure'));
        this.searchContainerEl = this.settings.target.querySelector('#spaGlobalSearchWidgetContainer');
        this.widgetReadyEvent = 'WIDGET_READY.widget-global-search-public-widget';
        if (this.params.inputExperience === 'stage') {
          this.loadGlobalSearchWidget(this.searchContainerEl);
        } else {
          this.smallSearchContainerEl = document.querySelector('.small-search .header-search');
          this.smallSearchContainerEl.id = 'smallSearchContainer';
          this.setupContainer();
        }
      } catch (error) {
        // Integrate Sparta Instrumenation Utility
        console.log(error);
      }
    } else {
      // Clone static form and append to the menu dropdown container
      this.formEl = this.settings.target.querySelector('.form');
      this.smallFormEl = this.formEl.cloneNode(true);
      this.smallSearchContainer = document.querySelector('.small-search .header-search');

      if (this.formEl && this.smallSearchContainer) {
        this.smallSearchContainer.appendChild(this.smallFormEl);
      }
    }
  }

  /**
   *
   * Called to load global search widget.
   * @param {*} searchContainer target node for widget
   * @returns {void}
   */
  loadGlobalSearchWidget(searchContainer) {
    const { env } = this.spaParams.siteParams;
    const { inputExperience, resultsExperience, resultsContainerId } = this.params;
    const isLocal = (env === 'local');

    try {
      const widgetBaseURL = isLocal ? 'http://localhost:3005' : '';
      const LOADER_VERSION = '5.1.2';
      const widgetsInitName = 'widgets.initialWidgetLoader.globalSearchWidget';
      const globalSearchWidget = {
        name: this.isAuth ? 'global-search-widget' : 'global-search-public-widget',
        version: '1.0.0',
        loaderVersion: LOADER_VERSION,
        container: searchContainer.id,
        path: widgetBaseURL,
        language: sparta.language || 'en',
        spinner: false,
        options: {
          inputExperience,
          resultsContainerId,
          resultsExperience,
          withoutCredentials: isLocal,
        },
        onload: this.spartaLoaderLoaded.bind(this),
      };

      // Homepage sites need stage for small and medium
      const homepageSites = ['homepage', 'hp-assets', 'notice-hp-outage'];

      if (this.viewport.indexOf('large') === -1
        && homepageSites.indexOf(spaParams.siteName) > -1) {
        globalSearchWidget.options.inputExperience = 'stage';
        globalSearchWidget.options.resultsExperience = 'flyout';
      }

      /**
       * Called to load global search widget.
       * @returns {void}
       */
      const spartaLoaderInitialized = () => {
        const initScript = document.querySelector(`[data-widget-name="${widgetsInitName}"]`);
        initScript.parentNode.removeChild(initScript);
        window.sparta.widgets[LOADER_VERSION].load(globalSearchWidget);
      };

      const addLoaderScript = () => {
        const loader = document.createElement('script');
        loader.type = 'text/javascript';
        loader.src = `${widgetBaseURL}/spa/widgets/loader/${LOADER_VERSION}/index.js`;
        loader.dataset.widgetName = widgetsInitName;
        loader.onload = spartaLoaderInitialized;
        document.body.appendChild(loader);
      };

      if (window.sparta && window.sparta.widgets && window.sparta.widgets[LOADER_VERSION]) {
        window.sparta.widgets[LOADER_VERSION].load(globalSearchWidget);
      } else if (document.readyState !== 'loading') {
        addLoaderScript();
      } else {
        window.addEventListener('DOMContentLoaded', () => {
          addLoaderScript();
        });
      }
    } catch (error) {
      // Integrate Sparta Instrumenation Utility
      console.log(error);
    }
  }

  /**
   * Called to setup search container
   * @returns {void}
   */
  setupContainer() {
    let ruleCheck = this.viewport.indexOf('small') > -1;

    if (this.params.rule === 'large') {
      ruleCheck = ruleCheck || this.viewport.indexOf('medium') > -1;
    }

    if (ruleCheck) {
      this.searchContainerEl.innerHTML = '';
      this.loadGlobalSearchWidget(this.smallSearchContainerEl);
    } else {
      this.smallSearchContainerEl.innerHTML = '';
      this.loadGlobalSearchWidget(this.searchContainerEl);
    }
  }

  /**
   * Sparta loader handler
   * @param {*} widget search widget
   * @returns {void}
   */
  spartaLoaderLoaded(widget) {
    widget.events.sub(this.widgetReadyEvent, () => {
      this.bindEvents();
    });
  }

  /**
   * Called to setup event listeners
   * @returns {void}
   */
  bindEvents() {
    if (this.params.inputExperience === 'stage' || this.eventsBound) return;

    this.eventsBound = true;

    this.Events.sub(spartaMediaQueryUtility.EVENTS.BREAKPOINT_CHANGE, (data) => {
      if (data && data.data && data.data.viewport) {
        this.viewport = data.data.viewport;
        this.setupContainer();
      }
    });
  }
}
